import { render, staticRenderFns } from "./BrandNewsList.vue?vue&type=template&id=0ab68304&scoped=true&"
import script from "./BrandNewsList.vue?vue&type=script&lang=js&"
export * from "./BrandNewsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab68304",
  null
  
)

export default component.exports